import { Expose } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class ChangeReason {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  description!: string | null;
  @IsBoolean()
  @Expose()
  isEnabled!: boolean;
}

export class ChangeReasonData {
  @IsOptional()
  @IsString()
  @Expose()
  description!: string | null;
  @IsString()
  @Expose()
  accountingChangeReasonName!: string;
}

export class AccountingChangeReason {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsArray()
  @Expose()
  internalChangeReasons: Array<ChangeReason> = [];
}
